import { useEffect, useRef, useState } from "react";
import { decryptData, defaulUrl } from "../components/const";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const Chomage = () => {

    const [annee, setAnnee] = useState((new Date()).getFullYear());
    const [load, setLoad] = useState(false);
    const [chomage, setChomage] = useState([]);
    const printElement = useRef();

    const handleShowRapport = () => {
        let status = 0;
        setLoad(true);
        fetch(`${defaulUrl}chomage/${annee}`, {
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + decryptData('ACCESS_TOKEN'),
                Accept: 'application/json',
                "Content-Type": "application/json"
            },
        }).then((response) => {
            status = response.status;
            return response.json();
        }).then(data => {
            setLoad(false);
            if (status === 200) {
                setChomage(data);
            }
        });
    };

    useEffect(() => {
        handleShowRapport();
    }, []);

    const handlePrintChomage = () => {
        if (!chomage?.length) return;

        const columns = [
            { header: "N°", dataKey: "index" },
            { header: "PRENOMS & NOM", dataKey: "nom" },
            { header: "TELEPHONE", dataKey: "phone" },
            { header: "FONCTION", dataKey: "fonction" },
            { header: "MAGASIN", dataKey: "magasin" },
            { header: "T. PRESENCE", dataKey: "nbPresence" },
            { header: "T. ABSENCE", dataKey: "nbAbsence" }
        ];

        const data = chomage.map((pers, ind) => ({
            index: ind + 1,
            nom: pers.nom,
            phone: pers.phone,
            fonction: pers.droit === 'Magasin' ? "Vendeur" : pers.droit,
            magasin: pers.magasin,
            nbPresence: pers.nbPresence,
            nbAbsence: pers.nbAbsence
        }));

        const doc = new jsPDF({ orientation: "landscape" });
        doc.setFontSize(14);
        doc.text(`Classement annuel du personnel par ordre de chômage - ${annee}`, 20, 20);

        autoTable(doc, {
            head: [columns.map(col => col.header)],
            body: data.map(row => columns.map(col => row[col.dataKey])),
            startY: 30,
            styles: { fontSize: 10 },
            headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
            theme: "grid"
        });

        doc.save(`Classement_Chomage_${annee}.pdf`);
    };

    return (
        <div className="chomage">
            {load && <div className="loader"></div>}
            <h6 className="text-primary">CLASSEMENT ANNUEL  DU PERSONNEL PAR ORDE DE CHOMAGE</h6>
            <div className="row py-2 align-items-center">
                <div className="col-md-2 pe-1 m-2">
                    <div className="form-group">
                        <label className="form-label">Années</label>
                        <select className="form-select" defaultValue={annee} onChange={(e) => setAnnee(e.target.value)}>
                            <option value="">Choisir une année</option>
                            <option value="2024">2024</option>
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                        </select>
                    </div>
                </div>
                <button className="btn btn-primary w-auto m-1 align-self-end" onClick={handleShowRapport}>
                    <i className="bx bx-show"></i>
                </button>
                <button className="btn btn-primary w-auto m-1 align-self-end" onClick={handlePrintChomage}>
                    <i className="bx bx-printer"></i> PDF
                </button>
                <div className="table-responsive" ref={printElement}>
                    <table className="table table-striped table-bordered table-hover">
                        <thead className="table-dark">
                            <tr className="align-middle text-center">
                                <th>N°</th>
                                <th>PRENOMS & NOM</th>
                                <th>TELEPHONE</th>
                                <th>FONCTION</th>
                                <th>MAGASIN</th>
                                <th>T. PRESENCE</th>
                                <th>T. ABSENCE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {chomage.map((pers, ind) => (
                                <tr key={ind}>
                                    <td>{ind + 1}</td>
                                    <td>{pers.nom}</td>
                                    <td>{pers.phone}</td>
                                    <td>{pers.droit === 'Magasin' ? "Vendeur" : pers.droit}</td>
                                    <td>{pers.magasin}</td>
                                    <td className="bg-success-subtle">{pers.nbPresence}</td>
                                    <td className="bg-danger-subtle">{pers.nbAbsence}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Chomage;
